import React, {FunctionComponent} from 'react';
import FooterLogo from '../../assets/icons/han_logo_footer.svg';

interface Props {}

const Footer: FunctionComponent<Props> = () => {

    const currentYear = new Date().getFullYear()

    return (
        <footer>
            <div className="footer">
                <div className="footer">
                    <div className="footer__container">
                        <div className="footer__container__branding">
                            <img className="footer__container__branding__logo" src={FooterLogo} alt="han logo"/>
                            <h6 className="footer__container__branding__year">{ currentYear }</h6>
                        </div>
                        <div className="footer__container__menu">
                            <h6 className="footer__container__menu__subtitle">Go to:</h6>
                            <a href={'https://specials.han.nl/sites/studyabroad/'} target={'_blank'} rel="noreferrer">Study Abroad Journey</a>
                            <a href={'https://han.moveon4.de/publisher/5/eng#'} target={'_blank'} rel="noreferrer">Study Abroad Partner Overview</a>
                            <a href={'https://hanuniversity.com/en/about-us/han-organization/business-units/international-office/'} target={'_blank'} rel="noreferrer">International Office</a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};
 
export default Footer;
